import { Controller } from '@hotwired/stimulus'
import { useDebounce } from 'stimulus-use'

export default class extends Controller {
  static targets = ['input', 'results', 'form', 'frame']
  static debounces = ['search']

  connect() {
    useDebounce(this, { wait: 400 })

    // Listen for turbo frame loads to show results
    if (this.hasFrameTarget) {
      this.frameTarget.addEventListener('turbo:frame-load', () => {
        if (this.inputTarget.value.trim() !== '') {
          this.showResults()
        }
      })
    }
  }

  search() {
    const query = this.inputTarget.value.trim()
    if (query === '') {
      this.hideResults()
      return
    }
    this.showResults()
    this.formTarget.requestSubmit()
  }

  showResults() {
    if (this.hasResultsTarget) {
      this.resultsTarget.classList.remove('d-none')
    }
  }

  hideResults() {
    if (this.hasResultsTarget) {
      this.resultsTarget.classList.add('d-none')
    }
  }

  hideResultsDelayed() {
    // Delay to allow clicking on results
    setTimeout(() => this.hideResults(), 200)
  }
}
